<template lang="pug">
.remind-modal
  b-modal(v-model="_value" size="xl" no-close-on-backdrop no-close-on-esc hide-header @ok="ok")
    .messages
      div 本日、以下の外出外泊届けがありますので、ご確認ください。

    .remind-modal-table
      .thead
        .header-line
          .th.type 種別
          .th.type 入力
          .th.status 状態
          .th.outing-date 日時
          .th.d-flex.flex-column.outing-resident
            .user 利用者名
            .room （部屋名）
          .th.d-flex.flex-column.outing-family
            .visitor 申請者（続柄）
            .visitor お迎えに来る方（続柄）
      .tbody
        .body-line(v-for="outing in _outings" :class="{ 'deleted-outing': outing.deleteFlag }")
          .td.type.center(v-if="outing.type == 'goingOut'") 外出
          .td.type.center(v-if="outing.type == 'stayingOut'") 外泊
          
          .td.input-type.center(v-if="outing.inputBy == 'family'") 本人
          .td.input-type.center(v-if="outing.inputBy == 'facility'") 代理

          .td.status.center(v-if="outing.deleteFlag == true") キャンセル済
          .td.status.center.status-consented(v-else-if="outing.consented") 承諾済
          .td.status.center.status-no-consented(v-else) 未承諾

          .td.outing-date(v-if="outing.type == 'goingOut'")
            .d-flex.flex-row(style="width: 100%;")
              span {{ getDate(outing.startDatetime) }}
              span （
              span(:class="weekCssClass(outing.startDatetime)") {{ getWeek(outing.startDatetime) }}
              span ）
              span {{ getTime(outing.startDatetime) }}
              span ～
              span {{ getTime(outing.endDatetime) }}
          .td.outing-date(v-if="outing.type == 'stayingOut'")
            .d-flex.flex-row(style="width: 100%;")
              span {{ getDate(outing.startDatetime) }}
              span （
              span(:class="weekCssClass(outing.startDatetime)") {{ getWeek(outing.startDatetime) }}
              span ）
              span {{ getTime(outing.startDatetime) }}
              span ～
            .d-flex.flex-row(style="width: 100%;")
              span {{ getDate(outing.endDatetime) }}
              span （
              span(:class="weekCssClass(outing.endDatetime)") {{ getWeek(outing.endDatetime) }}
              span ）
              span {{ getTime(outing.endDatetime) }}

          .td.outing-resident
            .d-flex.flex-column
              .user {{ outing.targetResidentInfo.name }}
              .room （{{ outing.targetResidentInfo.roomName }}）

          .td.outing-family
            .d-flex.flex-column
              .d-flex.flex-row.flex-wrap
                .family-name {{ outing.applicantFamilyInfo.name }}
                .family-relation （{{ outing.applicantFamilyInfo.relation }}）
              .d-flex.flex-row.flex-wrap
                .applicant-pickup(v-if="outing.applicantPickup") 申請者と同じ
                .applicant-pickup(v-else) {{ outing.pickupPerson.name }}（{{ outing.pickupPerson.relation }}）
      
    .loading(v-show="isLoading")
      .loading-msg
        b-spinner.spinner
        span.message.align-self-center 読込み中...

    template(#modal-footer="{ ok }")
      .d-flex.flex-row.justify-content-end.align-items-center(style="width:100%;")
        .flex-fill.mr-2
          b-form-checkbox(v-model="showCanceled") キャンセル済を表示
        b-button.btn.modal-ok-btn(@click="print") 印刷
        b-button.btn.modal-ok-btn(@click="ok") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { OutingGetModel } from "@/commons/services/Outings";

/**
 * ### 面会予約のリマインドモーダル
 */
@Component
export default class RemindReservatoinModal extends Vue {
  /** 予約 */
  @Prop({
    required: true
  })
  value!: boolean;
  /** 予約 */
  @Prop({ required: true })
  outings!: Array<OutingGetModel>;
  /** ローディング表示可否 */
  @Prop({
    required: true
  })
  isLoading!: boolean;

  /** 削除済みを表示するか否か */
  showCanceled: boolean = false;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _outings(): Array<OutingGetModel> {
    return this.outings.filter((outing) => {
      // 削除済を表示する場合、全レコードを表示させる
      if (this.showCanceled == true) {
        return true;
      }
      // 削除済を表示しない場合、削除されていないレコードのみを表示させる
      else {
        if (outing.deleteFlag == false) {
          return true;
        } else {
          return false;
        }
      }
    });
  }

  /**
   * 日付(yyyy年mm月dd日)を返す
   * */
  public getDate(date: number): string {
    return this.$dateUtil.convertNumberToString(date, "mm/dd");
  }

  /**
   * 曜日を返す
   */
  public getWeek(date: number): string {
    const dateObject: Date = this.$dateUtil.convertNumberToDate(date);
    return this.$dateUtil.getWeekName(dateObject, "ja");
  }

  /**
   * 曜日の文字色CssClassの割り当て
   */
  public weekCssClass(date: number): string {
    let weekClassName: string = "";
    const weekName: string = this.getWeek(date);
    switch (weekName) {
      case "日":
        weekClassName = "sunday";
        break;
      case "土":
        weekClassName = "saturday";
        break;
      default:
        break;
    }

    return weekClassName;
  }

  /**
   * 時分を返す
   */
  public getTime(date: number): string {
    return this.$dateUtil.convertNumberToString(date, "hh:MM");
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }

  public async print(): Promise<void> {
    this.$emit("print", this.showCanceled);
    return;
  }
}
</script>
